export const ReferenceNumbers = [
  { label: "Customer Reference", value: "CR", display: false },
  { label: "Purchase Order", value: "PO", display: false},
  { label: "Shipper Order", value: "SO", display: false },
  { label: "", value: "BN", display: false },
  { label: "Carrier Reference", value: "CN", display: false },
  { label: "Shipper Identifier", value: "SI", display: false },
  { label: "Delivery Order", value: "DO", display: false },
  { label: "Pick Up", value: "P8", display: false }
];
